module.exports = __webpack_public_path__ + "images/332e3372b20818515627f66d9d93fd5c7.svg";